import styled from 'styled-components';
export const StyledSpan = styled.span`
  height: 10px;
  border-radius: 3px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-lines-cells 1.6s infinite linear;
  display: inline-block;
  min-width: 15px;

  @keyframes shine-lines-cells {
    0% {
      opacity: 0.4;
    }
    40% {
      opacity: 0.8;
    }
    100% {
      opacity: 0.4;
    }
  }
`;